<ng-container>
  <div class="collapse-container">
    <h2 (click)="toggleCollapsed()" class="p-20">
      @if (showTextTitle) {
        <span class="text-title">{{ title | translate}}</span>
      }
      @if (direction === 'topToBottom' && !isCollapsed) {
        <i class="chevron icon-chevron-up icon-collapse"></i>
      }
      @if (direction === 'topToBottom' && isCollapsed) {
        <i class="chevron icon-chevron-down icon-collapse"></i>
      }

      @if (direction === 'rightToLeft' && !isCollapsed) {
        <i class="chevron icon-chevron-right icon-collapse"></i>
      }
      @if (direction === 'rightToLeft' && isCollapsed) {
        <i class="chevron icon-chevron-left icon-collapse"></i>
      }
    </h2>
    @if (!isCollapsed) {
      <div class="pb-20 px-20">
        <hr>
          <ng-content selection="[content]"></ng-content>
        </div>
      }
    </div>
  </ng-container>